<!--普通数据表格-->
<template>
  <div>
    <el-table
      ref="multipleTable"
      v-loading="config.loading"
      :element-loading-text="config.loadtext"
      :data="tableData"
      border
      stripe
      :height="config.height"
      :max-height="config.maxHeight"
      highlight-current-row
      style="width: 100%; overflow-y: auto;"
      :cell-style="cellStyle"
      @row-dblclick="rowDblclick"
      @cell-click="cellClick"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        label="序号"
        align="center"
        :fixed="config.fixed"
        :width="config.indexWidth">

        <!-- eslint-disable-next-line -->
        <template slot="header" slot-scope="scope">
          <div>
            <div style="line-height: 14px;">序号</div>
          </div>



        </template>


        <template slot-scope="scope">
          {{ (config.currentPage-1) * config.pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        v-for="item in tableLabel"
        v-if="!(item.isShow || item.isShow === 'false')"
        :key="item.prop"
        :sortable="item.sortable"
        :label="item.label"
        :fixed="item.fixed"
        :width="item.width ? item.width : ''"
        :align="item.aligin ? item.aligin : 'center'"
        header-align="center"
        show-overflow-tooltip
      >

        <template slot-scope="scope">
          <el-link v-if="item.click" type="primary">{{ scope.row[item.prop] }}</el-link>
          <el-select v-else-if="item.type === 'Select'" v-model="scope.row[item.prop]" type="Select" size="mini" placeholder="" @click.native="clickEvent(scope.row)" @change="selectChangeEvent(scope.row)">
            <el-option
              v-for="selectItem in item.options"
              :key="selectItem.value"
              :label="selectItem.label"
              :value="selectItem.value">
            </el-option>
          </el-select>
          <span v-else style="text-align: center;">{{ scope.row[item.prop] }}</span>

        </template>
      </el-table-column>


    </el-table>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'DataTables',
  props: {
    tableLabel: Array,
    tableData: Array,
    config: {
      searchTables :{
        Boolean,
        default : true
      },
      height: {
        String,
        default: '75vh'
      },
      indexWidth: {
        String,
        default: '85%'
      }
    },
    pickerOptions: {}
  },
  data() {
    return {
    }
  },
  methods: {
    cellClick (row, column, cell, event) {
      this.$emit('cellClick', row, column, cell, event)
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let str = ''
      this.$emit('cellStyle', { row, column, rowIndex, columnIndex }, val => {
        str = val
      })

      return str
    },
    rowDblclick(row, column, event) {
      this.$emit('rowDblclick',row, column, event)
    },
    searchTable() {
      this.$emit('searchTable')
    },
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange',val)
    },
    selectChangeEvent(row) {
      this.$emit('selectChangeEvent', row)
    },
    clickEvent(row) {
      this.$emit('clickEvent', row)
    }
  }
}
</script>

<style scoped>
 /deep/ .button-size {
    height: 28px;
    float: left;
    line-height: 0px;
    align-items: center;
    justify-content: center;
  }
 /deep/ .el-button--mini, .el-button--mini.is-round {
   padding: 7px 9px;
 }
  /* el-divider 修改高度、效果 */
  .el-divider--horizontal{
    margin: 3px 0;
    border-top: 1px dashed #e8eaec;
  }
  /*更改字号*/
  .el-table {
    font-size: 12px;
    color: #606266;
    margin: 10px 10px;
  }
  /*更改高度*/
  .el-table {
    height: 40%;
  }
  /*缩小表格间距*/
  .el-table /deep/.cell {
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:nowrap;
    word-break: break-all;
    line-height: 12px;
    padding-right: 10px;
  }
  .el-table th>.cell{
     display: inline-block;
     white-space: nowrap;
     word-break: keep-all;
     text-overflow: unset;
   }

 /deep/ .el-link {
    font-weight: 500;
    font-size: 12px;
  }
  /deep/.bluecell{
    color: #3A71A8;
  }

  body .el-table th.gutter{
  display: table-cell!important;
}
body .el-table colgroup.gutter{
  display: table-cell!important;
}

</style>
